<template>
  <div>
    <div>
      <div style="display: flex;justify-content: space-between">
        <div>
          <el-form :inline="true" class="demo-form-inline" label-position="right" label-width="100px" :model="searcheForm" >
            <el-form-item label="订单编号：">
              <el-input placeholder="请输入订单编号" clearable width="180px" v-model="searcheForm.localOrderNumber" ></el-input>
            </el-form-item>
            <el-form-item label="订单金额：">
              <el-input placeholder="请输入订单金额" clearable width="180px" v-model="searcheForm.payAmount" ></el-input>
            </el-form-item>
            <el-form-item label="桩号：" label-width="300">
              <el-input placeholder="请输入桩号" clearable width="180px" v-model="searcheForm.chargerNum" ></el-input>
            </el-form-item>
            <el-form-item label="插座号：" label-width="300">
              <el-input placeholder="请输入插座号" clearable width="180px" v-model="searcheForm.connectorCode" ></el-input>
            </el-form-item>
            <el-form-item label="订单状态：" label-width="300">
              <el-input placeholder="请输入订单状态" clearable width="180px" v-model="searcheForm.payStatus" ></el-input>
            </el-form-item>
            <el-form-item label="订单创建日期：" label-width="300">
              <el-input placeholder="请输入订单创建日期" clearable width="180px" v-model="searcheForm.createTime" ></el-input>
            </el-form-item>

            <el-button icon="el-icon-search" type="primary" @click="initUsers">搜索</el-button>
          </el-form>
        </div>
      </div>
    </div>
    <!-- 表格 start -->
    <div style="margin-top: 30px">
      <el-table :data="orderList" stripe border v-loading="loading" element-loading-text="正在加载..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" style="width: 100%" >
        <el-table-column type="selection" align="center" width="44"></el-table-column>
        <el-table-column prop="equipmentCode" label="充电桩编码" width="120" align="center" fixed="left"></el-table-column>
        <el-table-column prop="connectorCode" label="插座号" width="80" align="center" fixed="left"></el-table-column>
        <el-table-column prop="localOrderNumber" label="订单编号" width="300" align="center" fixed="left" ></el-table-column>
        <el-table-column prop="payStatus" label="订单状态" width="100" align="center" :formatter="payStatus" ></el-table-column>
        <el-table-column prop="startTime" label="开始时间 " width="180" align="center"></el-table-column>
        <el-table-column prop="endTime" label="结束时间 " width="180" align="center"></el-table-column>
        <el-table-column prop="payAmount" label="订单金额 " width="95" align="center"></el-table-column>
        <el-table-column prop="phoneNum" label="支付人手机号" width="400" align="center"></el-table-column>
        <el-table-column prop="createTime" label="订单创建日期" width="400" align="center"></el-table-column>
        <el-table-column prop="remark" label="备注" width="400" align="center"></el-table-column>
        <el-table-column fixed="right" label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button @click="showEditEmpView(scope.row)">查看</el-button>
            <!-- <el-button @click="deleteUser(scope.row)" type="danger">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <div style="display: flex;justify-content: flex-end">
        <el-pagination background @current-change="currentChange" @size-change="sizeChange" layout="sizes, prev, pager, next, jumper, ->, total, slot" :total="total" ></el-pagination>
      </div>
    </div>
    <!-- 表格 END -->
    <el-dialog :title="title" :visible.sync="dialogVisible" width="500px">
      <div>
        <el-form :model="user" ref="userForm" label-position="right" label-width="80px">
          <el-form-item label="姓名:" prop="name">
            <el-input size="mini" style="width: 100%" prefix-icon="el-icon-edit" v-model="user.name" placeholder="请输入员工姓名" ></el-input>
          </el-form-item>

          <el-form-item label="性别:" prop="gender">
            <el-radio-group v-model="user.gender" style="margin-top: 13px;">
              <el-radio label="1">男</el-radio>
              <el-radio label="0">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- <el-form-item label="密码：" prop="password">
            <el-input size="mini" show-password style="width: 100%" prefix-icon="el-icon-edit" v-model="user.password" placeholder="请输入密码"></el-input>
          </el-form-item>-->
          <el-form-item label="角色：" prop="roles">
            <el-select style="width: 100%" v-model="user.roleIds" multiple placeholder="请选择角色">
              <el-option v-for="item in rolesOptions" :key="item.id" :label="item.nameZh" :value="item.id" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="手机号:" prop="phone">
            <el-input size="mini" style="width: 100%" prefix-icon="el-icon-edit" v-model="user.phone" placeholder="请输入手机号" ></el-input>
          </el-form-item>
          <el-form-item label="是否启用:" prop="enabled">
            <el-switch style="margin-top: 10px;" v-model="user.enabled" active-color="#13ce66" inactive-color="#ff4949" ></el-switch>
          </el-form-item>
          <el-form-item label="联系地址:" prop="address">
            <el-input size="mini" style="width: 100%" prefix-icon="el-icon-edit" v-model="user.address" placeholder="请输入联系地址" ></el-input>
          </el-form-item>
          <el-form-item label="备注:" prop="remark">
            <el-input type="textarea" v-model="user.remark"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="doAddUser">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  deleteRequest,
  putRequest,
  getRequest,
  postRequest,
} from "../../utils/api";

export default {
  name: "OrderList",
  data() {
    return {
      title: "", //模态窗口 标题
      searcheForm: {}, //搜索
      orderList: [], //列表数据
      rolesOptions: [],
      loading: false,
      dialogVisible: false, // 是否显示 模态窗口
      total: 0,
      page: 1,
      size: 10,
      user: {},
      userForm: {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          {
            min: 2,
            max: 15,
            message: "长度在 2 到 15 个字符",
            trigger: "blur",
          },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { min: 11, max: 11, message: "长度是 11  个字符", trigger: "blur" },
        ],
        gender: [{ required: true, message: "请选择性别", trigger: "change" }],
        address: [{ required: true, message: "请填写地址", trigger: "blur" }],
        remark: [{ required: true, message: "请填写备注", trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.initUsers();
    getRequest("/api/system/basic/permiss/").then((res) => {
      this.rolesOptions = res;
    });
  },
  methods: {
    payStatus(row, column) {
      const status = row.chargingStatus;
      if (status === 0) {
        return "未启动"
      }
      if (status === 1) {
        return "充电中"
      }
      if (status === 2) {
        return "已完成"
      }
      if (status === 3) {
        return "充电失败"
      }
      if (status === 4) {
        return "故障"
      }
    },
    //编辑用户按钮
    showEditEmpView(data) {
      this.title = "编辑用户信息";
      this.user = data;
      this.dialogVisible = true;
    },
    //添加用户 && 更新用户
    doAddUser() {
      let url;
      if (this.user.id) {
        url = putRequest(`/api/system/user/`, this.user);
      } else {
        url = postRequest(`/api/system/user/addUser`, this.user);
      }
      this.$refs["userForm"].validate((valid) => {
        if (valid) {
          url.then((resp) => {
            if (resp) {
              this.dialogVisible = false;
              this.initUsers();
            }
          });
        }
      });
    },
    // 页大小
    sizeChange(currentSize) {
      this.size = currentSize;
      this.initUsers();
    },
    // 选择页
    currentChange(currentPage) {
      this.page = currentPage;
      this.initUsers("advanced");
    },
    // 查询用户列表
    initUsers(type) {
      this.loading = true;
      postRequest(
        `/api/order/?page=${this.page}&size=${this.size}`,
        this.searcheForm
      ).then((resp) => {
        this.loading = false;
        if (resp) {
          this.orderList = resp.data.list;
          this.total = resp.data.total;
        }
      });
    },
  },
};
</script>

<style>
/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
  transition: all 0.8s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>